/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Input,
  Col,
} from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const AutoFillableFormItem = ({
  label,
  name,
  getter,
  formatter,
  colBreakPoints,
  filterById,
}) => {
  const formInstance = Form.useFormInstance();
  const [loading, setLoading] = useState(false);
  const value = Form.useWatch(name, formInstance);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const data = typeof value === 'number'
        ? await getter(filterById ? value : { id: value })
        : value;
      const obj = Array.isArray(data?.results || data) ? (data?.results || data)[0] : data;
      setLoading(false);
      if (!obj) {
        formInstance.setFieldsValue({ [`${name}_info`]: `Error al obterner ${label}` });
        return;
      }
      const formatted = formatter(obj);
      formInstance.setFieldsValue({ [`${name}_info`]: formatted });
    };

    if (value) {
      formInstance.setFieldsValue({ [`${name}_info`]: `Obteniendo ${label}` });
      fetchData();
    } else {
      formInstance.setFieldsValue({ [`${name}_info`]: `Sin ${label}` });
    }
  }, [value]);

  return (
    <>
      <Form.Item name={name} hidden><Input disabled /></Form.Item>
      {colBreakPoints ? (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Col {...colBreakPoints}>
          <Form.Item label={label} name={`${name}_info`}>
            <Input disabled addonAfter={loading ? <LoadingOutlined /> : null} />
          </Form.Item>
        </Col>
      ) : (
        <Form.Item label={label} name={`${name}_info`}>
          <Input disabled addonAfter={loading ? <LoadingOutlined /> : null} />
        </Form.Item>
      )}
    </>
  );
};

AutoFillableFormItem.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  getter: PropTypes.string.isRequired,
  formatter: PropTypes.string.isRequired,
  colBreakPoints: PropTypes.string.isRequired,
  filterById: PropTypes.bool,
};

AutoFillableFormItem.defaultProps = {
  filterById: false,
};

export default AutoFillableFormItem;
